import React from "react";
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import EstimateExitButton from "./EstimateExitButton";
import {ValidationSummary} from "devextreme-react/validation-summary";
import {Item, Box} from "devextreme-react/box";
import {CustomerInformationControl} from "./CustomerInformationControl";
import {Button} from "devextreme-react/button";
import {StoreInformationControl} from "./StoreInformationControl";
import { useEEToolContext } from "../contexts/eeToolContext";

export function EEInfoControl({onContinue}: { onContinue: () => void }) {
    const context = useEEToolContext();

return <div>
        <Toolbar className='button-toolbar'>
            <ToolbarItem location={'before'}>
                <Button text='Continue' validationGroup='newEstimateValidationGroup' onClick={async (e) => {
                    let result = e.validationGroup.validate();
                    if (result.isValid) {
                        onContinue();
                    }
                }}
                />
            </ToolbarItem>
            <ToolbarItem location={'before'}>
                <EstimateExitButton/>
            </ToolbarItem>
        </Toolbar>
        <ValidationSummary validationGroup='newEstimateValidationGroup'></ValidationSummary>
        <Box>
            <Item ratio={1}>
                <CustomerInformationControl/>
            </Item>
            <Item ratio={1}>

            </Item>
            <Item ratio={1}>
                <StoreInformationControl/>
            </Item>
        </Box>
    </div>;
}